import { createApi } from "@reduxjs/toolkit/query/react";
import { RootState } from "../../reducers";
import { axiosBaseQuery } from "../../axiosBaseQuery";

export const topUsersApi = createApi({
  reducerPath: "topUsersApi",
  baseQuery: (args, api) => {
    const state = api.getState() as RootState;

    const token = state.auth.access;

    let headers: Record<string, string> = {};
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    return axiosBaseQuery({
      baseUrl: process.env.REACT_APP_BASE_URL,
    })({ ...args, headers });
  },
  endpoints: (builder) => ({
    getTopUsers: builder.query({
      query: ({
        startDate = null,
        endDate = null,
      }: {
        startDate?: Date | null | undefined | string;
        endDate?: Date | null | undefined | string;
      }) => ({
        url: `auth/top_users?start_date=${startDate}&end_date=${endDate}&users_count=10`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetTopUsersQuery } = topUsersApi;
